import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import { axiosNoAuth } from "../config/axiosInstance"

export const fetchCoursesList = createAsyncThunk(
    'fetchCoursesList/CourseAndSkillList',
    async () => {
        const response = await axiosNoAuth.get('https://xgfy-czuw-092q.m2.xano.io/api:ZZCtun0K/all_xano_course_names')
        return response.data
    }
)

export const fetchSkillList = createAsyncThunk(
    'fetchSkillList/CourseAndSkillList',
    async ({ course_slug }) => {
        const response = await axiosNoAuth.get('https://xgfy-czuw-092q.m2.xano.io/api:ZZCtun0K/skills_in_course_for_personalize', {
            params: {
                course_slug: course_slug
            }
        })

        return response.data
    }
)

export const fetchSearchedSkillList = createAsyncThunk(
    'fetchSearchedSkillList/CourseAndSkillList',
    async ({ value }) => {
        const response = await axiosNoAuth.get('https://xgfy-czuw-092q.m2.xano.io/api:ZZCtun0K/search_xano_course', {
            params: {
                search: value
            }
        })

        return response.data
    }
)




const initialState = {
    courses: [],
    skills: [],
    searchedSkills: [],
    searchLoading: false,
    courseLoading: false,
    skillLoading: false,
    showCategoryModal: false
}

const courseAndSkillSlice = createSlice({
    name: 'courseAndSkill',
    initialState,
    reducers: {
        setSearchedSkill: (state, action) => {
            state.searchedSkills = action.payload
        },
        setShowCategoryModal: (state, action) => {
            state.showCategoryModal = action.payload
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchCoursesList.pending, (state) => {
            state.courseLoading = true
        })
        builder.addCase(fetchCoursesList.fulfilled, (state, action) => {
            state.courseLoading = false
            state.courses = action.payload
        })
        builder.addCase(fetchSkillList.pending, (state) => {
            state.skillLoading = true
        })
        builder.addCase(fetchSkillList.fulfilled, (state, action) => {
            state.skillLoading = false
            state.skills = action.payload
        })
        builder.addCase(fetchSearchedSkillList.pending, (state) => {
            state.searchLoading = true
        })
        builder.addCase(fetchSearchedSkillList.fulfilled, (state, action) => {
            state.searchLoading = false
            state.searchedSkills = action.payload?.skills
        })
        
    }
})

export const { setSearchedSkill, setShowCategoryModal } = courseAndSkillSlice.actions
export const selectCourseAndSkillList = (state) => state.courseAndSkill
export const selectCourses = (state) => state.courseAndSkill.courses
export const selectSkills = (state) => state.courseAndSkill.skills
export const selectSearchedSkills = (state) => state.courseAndSkill.searchedSkills
export const selectShowCategoryModal = (state) => state.courseAndSkill.showCategoryModal
export default courseAndSkillSlice.reducer